import { useState, useCallback } from 'react';
import { message } from 'antd';
import { useAuthContext } from '../../../shared/contexts/AuthContext';

export const useLogout = () => {
  const { logout: clearAuthState, user: currentUser } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const logout = useCallback(async () => {
    if (!currentUser) {
      console.warn('Logout called but no user is logged in.');
      clearAuthState();
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      console.log('Logging out user:', currentUser);

      // Clear auth state in context and localStorage
      clearAuthState();
      message.success('Logged out successfully');
    } catch (err: any) {
      console.error('Logout error:', err);
      // Clear the local auth state even on error
      clearAuthState();

      const errorMessage = err.message || 'Error during logout, but session was cleared';
      setError(errorMessage);
      message.warning('Session cleared');
    } finally {
      setIsLoading(false);
    }
  }, [currentUser, clearAuthState]);

  return { logout, isLoading, error };
};
